var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartLineGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V15.8333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.2746 12.2366C6.95982 12.5724 6.43246 12.5894 6.0967 12.2746C5.76094 11.9598 5.74393 11.4325 6.0587 11.0967L9.1837 7.76338C9.48813 7.43866 9.994 7.4105 10.3326 7.69942L12.799 9.80412L16.0126 5.73362C16.2978 5.37239 16.8218 5.31074 17.183 5.59592C17.5443 5.88111 17.6059 6.40513 17.3207 6.76636L13.5707 11.5164C13.2778 11.8874 12.7353 11.9407 12.3757 11.6339L9.85567 9.48346L7.2746 12.2366Z",
    fill: "#A8ABAE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLineGrey);
export default __webpack_public_path__ + "static/media/chart-line-grey.5a790fd5a3aabfb72612b8bf3685f6b4.svg";
export { ForwardRef as ReactComponent };